import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreSchool as apiRestoreSchool } from "../../api/apiSchools";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreSchool() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: restoreSchool, isPending: isRestore, data: results, error } = useMutation({
        mutationFn: (id) => apiRestoreSchool(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["schools"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { restoreSchool, isRestore, error, results };
}
